var _a;
// import { IUser } from '@/models/UserModel';
import { createSlice } from '@reduxjs/toolkit';
var authInitialState = {
    token: false,
    currentUser: null,
};
var slice = createSlice({
    name: 'Auth',
    initialState: authInitialState,
    reducers: {
        setToken: function (state) {
            state.token = true;
        },
        setCurrentUser: function (state, action) {
            state.currentUser = action.payload;
        },
        deleteToken: function (state) {
            state.token = false;
        },
    },
});
export var setToken = (_a = slice.actions, _a.setToken), deleteToken = _a.deleteToken, setCurrentUser = _a.setCurrentUser;
export var authReducer = slice.reducer;
